import React from 'react'

import { i18n } from '~/i18n'

import type { TokenizedCreditCard } from '../../../types'

type Props = {
  creditCard?: TokenizedCreditCard
}

export default function Note(props: Props) {
  if (!props.creditCard) return null
  return (
    <p className="save-card-disclaimer disclaimer">
      {i18n.t('components.save_card_on_file.note')}
    </p>
  )
}
